import { DeleteOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "../button";
import { useDeleteModal } from "@/shared/modal/delete-verification-modal/use-delete-modal";
import { DeleteVerificationModal } from "@/shared/modal/delete-verification-modal/delete-verification-modal";
import { ReactNode } from "react";

export type DeleteButtonProps = Omit<ButtonProps, "onClick" | "title"> & {
  onClick?: () => void;
  title?: ReactNode;
  description?: ReactNode;
};

export function DeleteButton({
  onClick,
  title,
  description,
  ...rest
}: DeleteButtonProps) {
  const { closeDeleteModal, open, setOpen } = useDeleteModal();

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        icon={<DeleteOutlined />}
        danger
        type="primary"
        {...rest}
      />
      <DeleteVerificationModal
        title={title}
        description={description}
        onClose={closeDeleteModal}
        onDelete={onClick}
        open={!!open}
      />
    </>
  );
}
